{
  "salon-search-container": {
    "text": {
      "find-salon": "Find your salon",
      "find-salon-hint": "Please select the desired city of the salon"
    }
  }
}
